module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/CLOVER@3x.png?1.0.17";